/* unplugin-vue-components disabled */import { render } from "./loginCommon.vue?vue&type=template&id=383ec5d6&scoped=true"
import script from "./loginCommon.vue?vue&type=script&lang=js"
export * from "./loginCommon.vue?vue&type=script&lang=js"

import "./loginCommon.vue?vue&type=style&index=0&id=383ec5d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383ec5d6"]])

export default __exports__